import { render } from "./ChannelComparisonTable.vue?vue&type=template&id=3165a12d&scoped=true"
import script from "./ChannelComparisonTable.vue?vue&type=script&lang=js"
export * from "./ChannelComparisonTable.vue?vue&type=script&lang=js"

import "./ChannelComparisonTable.vue?vue&type=style&index=0&id=3165a12d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3165a12d"]])

export default __exports__